import { render, staticRenderFns } from "./OsReabertas.vue?vue&type=template&id=6058690a&"
import script from "./OsReabertas.vue?vue&type=script&lang=js&"
export * from "./OsReabertas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports